module.exports = __webpack_public_path__ + "static/media/file.c1b9051b.png";